import { inject, provide, type Ref } from "vue";

import type { Maybe } from "shared/types";

import { MODAL_FOCUS_TRAP_TARGET } from "./constants";

export function provideModalFocusTrapTarget(
  target: Ref<Maybe<HTMLElement>>
): void {
  provide(MODAL_FOCUS_TRAP_TARGET, target);
}

export function useModalFocusTrapTarget(): Maybe<Ref<Maybe<HTMLElement>>> {
  return inject(MODAL_FOCUS_TRAP_TARGET, undefined);
}

export default useModalFocusTrapTarget;
